import { TimeFrameLabels } from 'app/shared/model/charts/time-frame-labels.enum';

export const TimeFrameLabelValues = {
  [TimeFrameLabels.AllTime]: 'all',
  [TimeFrameLabels.CurrentWeek]: 'currentWeek',
  [TimeFrameLabels.CurrentMonth]: 'currentMonth',
  [TimeFrameLabels.CurrentQuarter]: 'currentQuarter',
  [TimeFrameLabels.Custom]: 'custom',
  [TimeFrameLabels.CurrentYear]: 'currentYear',
  [TimeFrameLabels.LastWeek]: 'lastWeek',
  [TimeFrameLabels.LastMonth]: 'lastMonth',
  [TimeFrameLabels.LastQuarter]: 'lastQuarter',
  [TimeFrameLabels.LastYear]: 'lastYear',
};
